module.exports = __webpack_public_path__ + "static/media/mousescroll.e2d34e32.svg";